import { render } from "./CreatePassForm.vue?vue&type=template&id=3043d644"
import script from "./CreatePassForm.vue?vue&type=script&lang=js"
export * from "./CreatePassForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__